import { Bot, Cpu, Sparkles, CheckCircle2, Loader2, Send } from "lucide-react";

// Sezione "Assistente AI" del portale: chat automatica con l'amministratore.
export const PortalChat = ({ chatMsgs, suggestions, chatBusy, sendChat, chatInput, setChatInput }) => (
  <div className="bg-card border border-border rounded-2xl p-4 backdrop-blur" data-testid="condomino-chat">
    <div className="flex items-center gap-2 mb-3">
      <div className="h-8 w-8 rounded-md bg-[#007BFF]/20 flex items-center justify-center"><Bot className="h-4.5 w-4.5 text-[#007BFF]" /></div>
      <div>
        <h3 className="font-head font-bold tracking-tight leading-tight">Chiedi all'amministratore</h3>
        <p className="text-[11px] text-muted-foreground">Fai domande sulle tue segnalazioni e sul tuo condominio.</p>
      </div>
    </div>

    <div className="flex items-start gap-2 text-[11px] text-muted-foreground bg-secondary/60 border border-border rounded-lg px-3 py-2 mb-3" data-testid="condomino-ai-disclosure">
      <Cpu className="h-3.5 w-3.5 text-[#007BFF] shrink-0 mt-0.5" />
      <span>
        Stai interagendo con un <strong className="text-foreground/80">assistente automatico (intelligenza artificiale)</strong>. Le risposte possono contenere errori e non sostituiscono le comunicazioni ufficiali dell'amministratore. Per questioni importanti contatta direttamente lo studio.{" "}
        <a href="/legale?doc=ai" target="_blank" rel="noopener noreferrer" className="text-[#007BFF] hover:underline">Informativa AI</a>
      </span>
    </div>

    <div className="space-y-3 max-h-96 overflow-y-auto pr-1" data-testid="condomino-chat-messages">
      {chatMsgs.length === 0 ? (
        <div className="py-4">
          <div className="text-xs text-muted-foreground/70 text-center mb-3">Chiedi all'amministratore del tuo condominio:</div>
          {suggestions.length > 0 ? (
            <div className="flex flex-col gap-2" data-testid="chat-suggestions">
              {suggestions.map((s, i) => (
                <button key={i} data-testid={`chat-suggestion-${i}`} disabled={chatBusy}
                  onClick={() => sendChat(s)}
                  className="text-left text-sm bg-card hover:bg-secondary border border-border hover:border-[#007BFF]/50 rounded-xl px-3.5 py-2.5 transition-colors disabled:opacity-50 flex items-center gap-2">
                  <Sparkles className="h-3.5 w-3.5 text-[#007BFF] shrink-0" />
                  <span className="text-foreground/80">{s}</span>
                </button>
              ))}
            </div>
          ) : (
            <div className="text-xs text-muted-foreground/70 text-center">Prova a chiedere: “A che punto è la mia segnalazione?” oppure “Chi è il tecnico assegnato?”</div>
          )}
        </div>
      ) : chatMsgs.map((m, i) => (
        <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-[#007BFF] text-white" : m.role === "system" ? "bg-green-500/15 text-green-300 border border-green-500/30 flex items-center gap-2" : "bg-secondary text-foreground/90"}`} data-testid={`chat-msg-${m.role}-${i}`}>
            {m.role === "system" && <CheckCircle2 className="h-4 w-4 shrink-0" />}
            {m.content || (chatBusy && i === chatMsgs.length - 1 ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "")}
          </div>
        </div>
      ))}
    </div>

    <div className="flex items-end gap-2 mt-3">
      <textarea
        data-testid="condomino-chat-input"
        value={chatInput}
        onChange={(e) => setChatInput(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendChat(); } }}
        onInput={(e) => { e.target.style.height = "auto"; e.target.style.height = Math.min(e.target.scrollHeight, 160) + "px"; }}
        rows={2}
        placeholder="Scrivi la tua domanda…  (Invio per inviare, Shift+Invio per andare a capo)"
        disabled={chatBusy}
        className="flex-1 resize-none bg-secondary border border-border rounded-lg px-3 py-2.5 text-sm outline-none focus:border-[#007BFF] disabled:opacity-50 min-h-[64px] max-h-[160px] leading-snug" />
      <button data-testid="condomino-chat-send" onClick={() => sendChat()} disabled={chatBusy || !chatInput.trim()}
        className="bg-[#007BFF] hover:bg-[#0069D9] text-white rounded-lg p-2.5 disabled:opacity-50 shrink-0">
        {chatBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
      </button>
    </div>
  </div>
);
